import React, { FC } from 'react'

import { IconFaceRecognitionProps } from './IconFaceRecognition.types'
import * as Styled from './styles/IconFaceRecognition.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFaceRecognition: FC<IconFaceRecognitionProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFaceRecognitionProps['size'],
  isResponsive = false,
}: IconFaceRecognitionProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M59.645 59.832a2.486 2.486 0 0 1-2.485-2.488v-3.461a2.486 2.486 0 1 1 4.973 0v3.46a2.487 2.487 0 0 1-2.489 2.489ZM42.324 47.254a2.487 2.487 0 0 1-2.488-2.488V42.18a2.49 2.49 0 0 1 2.488-2.489 2.489 2.489 0 0 1 2.485 2.489v2.586a2.487 2.487 0 0 1-2.485 2.488Zm34.731-.098a2.49 2.49 0 0 1-2.489-2.488V42.18a2.49 2.49 0 0 1 2.489-2.489 2.49 2.49 0 0 1 2.488 2.489v2.488a2.49 2.49 0 0 1-2.488 2.488ZM59.645 79.7a21.672 21.672 0 0 1-11.235-3.153 2.487 2.487 0 0 1 2.574-4.254 16.7 16.7 0 0 0 17.325 0 2.482 2.482 0 0 1 2.53-.11 2.478 2.478 0 0 1 1.313 2.169c.008.91-.476 1.75-1.273 2.195a21.652 21.652 0 0 1-11.235 3.152ZM32.64 104.766H17.72a2.486 2.486 0 0 1-2.485-2.485V87.359a2.487 2.487 0 1 1 4.973 0v12.434h12.434a2.487 2.487 0 1 1 0 4.973ZM17.719 35.129a2.487 2.487 0 0 1-2.485-2.488V17.719a2.486 2.486 0 0 1 2.485-2.485H32.64a2.487 2.487 0 1 1 0 4.973H20.207v12.434a2.487 2.487 0 0 1-2.488 2.488Zm84.562 0a2.487 2.487 0 0 1-2.488-2.488V20.207H87.359a2.487 2.487 0 1 1 0-4.973h14.922a2.486 2.486 0 0 1 2.485 2.485V32.64a2.487 2.487 0 0 1-2.485 2.488Zm.031 69.637H87.387a2.486 2.486 0 0 1 0-4.973h12.437V87.359a2.488 2.488 0 1 1 4.973 0v14.922a2.486 2.486 0 0 1-2.485 2.485Z'
          fill='#E60000'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconFaceRecognition
